<template>
  <cost-prices-rule-detail
    ref="costPricesRuleDetail"
    type="new"
    :submitting="submitting"
    @submit="submit"
  />
</template>
<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CostPricesRuleDetail from './CostPricesRuleDetail.vue';

export default {
  components: {
    CostPricesRuleDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      data: {}
    };
  },
  methods: {
    submit(data) {
      this.submitting = true;

      useService.pricingService
        .createProviderRule(data)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'cost-prices-rules' });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
